import React, { useRef } from 'react';
import { cn } from './lib/utils';
import { Icon } from './icon';

/*
    Token input — renders `selected` values as removable pills
    followed by a free-text input. Port of ~co/common/select/multi.
*/
export const MultiSelect = React.forwardRef(function MultiSelect(
  { icon = '', selected = [], onSelectedChange, onChange, onKeyDown, onKeyUp, onBlur, className = '', ...etc },
  forwardedRef,
) {
  const preventBlur = useRef(false);

  const onAddToken = (e) => {
    const value = (e.target.value || '').trim();
    if (!value) return;

    if (!selected.includes(value)) {
      e.preventDefault();
      onSelectedChange([...selected, value]);
    }
    e.target.value = '';
    onChange && onChange(e);
  };

  const onInputKeyDown = (e) => {
    const value = (e.target.value || '').trim();

    //remove
    if (e.key === 'Backspace' && !value)
      onSelectedChange(selected.slice(0, -1));
    //add on comma
    else if (e.key === ',' && value.length > 1) {
      e.target.value = e.target.value.replace(/,/gi, '');
      onAddToken(e);
    }

    onKeyDown && onKeyDown(e);
  };

  const onInputKeyUp = (e) => {
    const value = (e.target.value || '').trim();

    //add, important to put it in KeyUp, to give time for parent component do something with Enter
    if (e.key === 'Enter' && value) onAddToken(e);

    onKeyUp && onKeyUp(e);
  };

  const onInputBlur = (e) => {
    onAddToken(e);

    if (preventBlur.current) return;
    onBlur && onBlur(e);
  };

  const onContainerClick = (e) => {
    e.currentTarget.querySelector('input').focus();
  };

  const onTokenMouseDown = () => {
    preventBlur.current = true;
  };

  const onTokenClick = (e) => {
    preventBlur.current = false;
    const token = e.currentTarget.getAttribute('data-token');

    onSelectedChange(selected.filter((item) => item != token));
  };

  return (
    <div
      className='ui-multi-select'
      data-disabled={etc.disabled}
      onClick={onContainerClick}
    >
      {(selected || []).map((item) => (
        <div
          key={item}
          className='ui-multi-select-token'
          data-token={item}
          onMouseDown={onTokenMouseDown}
          onClick={onTokenClick}
        >
          <div className='ui-multi-select-token-content'>
            {icon && (
              <>
                <Icon
                  className='ui-multi-select-token-icon'
                  name={icon}
                  size='micro'
                />
                <Icon
                  className='ui-multi-select-token-close'
                  name='close'
                  size='micro'
                />
              </>
            )}
            <div className='ui-multi-select-token-title'>{item}</div>
          </div>
        </div>
      ))}

      <input
        className={cn('ui-multi-select-input', className)}
        type='text'
        autoComplete='off'
        autoCapitalize='none'
        spellCheck='false'
        {...etc}
        value={etc.value || ''}
        ref={forwardedRef}
        onBlur={onInputBlur}
        onKeyDown={onInputKeyDown}
        onKeyUp={onInputKeyUp}
      />
    </div>
  );
});
